export const GET_LEAD = 'GET_LEAD'
export const GET_LEAD_SUCCESS = 'GET_LEAD_SUCCESS'
export const GET_LEAD_ERROR = 'GET_LEAD_ERROR'

export interface LeadState {
  url: string | null
  loading: boolean
  error: boolean
}

export const InitialStateLead: LeadState = {
  url: null,
  loading: true,
  error: false,
}

export interface GetLead {
  type: typeof GET_LEAD
  payload: null
}

export interface GetLeadSuccess {
  type: typeof GET_LEAD_SUCCESS
  payload: any
}

export interface GetLeadError {
  type: typeof GET_LEAD_ERROR
  payload: boolean
}

export type LeadActions = GetLead | GetLeadSuccess | GetLeadError
